<template>
  <div class="content-wrap">
    <div class="user-box" v-if="user">
      <div class="user-flag" v-if="!user.isCheckMemFee && !user.isMemValid">未缴纳年费</div>
      <div class="user-flag-ing" v-if="user.isCheckMemFee">会费确认中</div>
      <div class="user-flag-yet" v-if="user.isMemValid == '1'">已缴纳会费</div>

      <div class="user-main">
        <div class="user-img">
          <img :src="user.portraitUrl" alt="" />
        </div>
        <div class="user-content">
          <div class="user-title-row">
            <span class="user-name">{{user.userName || '-'}}</span>
            <span class="user-type-tag" v-if="user.memTypeText">{{user.memTypeText}}</span>
          </div>
          <div class="user-meta-row">
            <span class="meta-item">
              <i class="meta-label">联系方式</i>
              <em>{{user.phone || '-'}}</em>
            </span>
            <span class="meta-divider"></span>
            <span class="meta-item meta-address">
              <i class="meta-label">通讯地址</i>
              <em :title="user.address || '-'">{{user.address || '-'}}</em>
            </span>
          </div>
          <div class="user-fee-row" v-if="memFeeRangeText">
            <span class="fee-chip">
              <i class="fee-label">会费期限</i>
              <em>{{memFeeRangeText}}</em>
            </span>
          </div>
          <div class="user-cert-row" v-if="showCertificateEntry">
            <button class="cert-entry-btn" type="button" @click="goCertificate">
              {{ certificateEntryText }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <FeeRemindBanner />

    <div class="banner-box">
      <div class="banner-name">暂未开放</div>
      <!--<div class="banner-desc">暂未开放</div>-->
      <div class="card-more">查看详情</div>
      <div class="banner-switch-box">
        <div class="banner-switch-icon"></div>
        <div class="banner-img-box">
          <img src="http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/peitu1%402x.png" alt="" />
        </div>
        <div class="banner-switch-icon"></div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-main-left">
        <div class="content-menu-box">
          <div class="content-menu-list">
            <div class="content-menu-item"
                :class="item === currentModule ? 'active' : ''"
                v-for="item in menuList"
                :key="item.id"
                @click="changeMenu(item)">
              <div class="content-menu-item-icon"></div>
              <div>{{item.name}}</div>
            </div>
          </div>
          <div class="content-menu-nav" v-if="currentModule.children">
            <div class="content-menu-nav-item"
              :class="item === currentItem ? 'active' : ''"
              v-for="item in currentModule.children"
              :key="item.id"
              @click="changeItem(item)"
            >{{item.name}}</div>
          </div>
        </div>
        <Component :is="currentModule.id" :c-id="currentItem.id" :hideTitle="true" />
        <!-- <div class="content-list-box">
          <div
            class="content-list-item"
            v-for="(item, index) in navList"
            :key="'list' + index"
          >
            <div class="content-list-item-header">
              <div class="content-list-item-left">
                <div class="content-list-item-num">浙园学【2022】</div>
                <h4>城市园林树木支撑技术规范培训</h4>
              </div>
              <div class="content-list-item-right">
                <div class="card-more">立即报名</div>
              </div>
            </div>
            <div class="content-list-item-extra">
              <div class="content-list-item-info">
                <div class="content-list-item-icon icon-position"></div>
                <div class="content-list-item-value">浙江杭州</div>
              </div>
              <div class="content-list-item-info">
                <div class="content-list-item-icon icon-time"></div>
                <div class="content-list-item-value">2022-10-20</div>
              </div>
            </div>
            <div class="content-list-item-body">
              <div class="content-list-item-body-item active">
                <div class="body-item-info">预交费</div>
                <div class="body-item-time">2022-10-20</div>
              </div>
              <div class="content-list-item-body-item">
                <div class="body-item-info">审核</div>
                <div class="body-item-time">2022-10-20</div>
              </div>
              <div class="content-list-item-body-item">
                <div class="body-item-info">续交费</div>
                <div class="body-item-time">2022-10-20</div>
              </div>
              <div class="content-list-item-body-item">
                <div class="body-item-info">报名取消</div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <!-- <div class="content-main-right">
        <div class="other-list">
          <div class="other-list-header">
            <img src="../../assets/images/detail-notice.png" alt="" />
          </div>
          <ul class="other-list-wrap">
            <li class="other-list-item hand">
              <div class="other-list-item-title">
                中华五千多年文明史的独特见证
              </div>
              <div class="other-list-item-time">2022-07-25 16:38:30</div>
            </li>
          </ul>
        </div>
        <div class="bottom-box">
          <img src="../../assets/tempImages/peitu2@2x.png" alt="" />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import FeeRemindBanner from './components/FeeRemindBanner';
import { mapState } from 'vuex';
import router from '@/router';

const menuList = [{
  id: 'Activity',
  name: '活动',
  children: [{
    id: 1,
    name: '培训'
  }, {
    id: 2,
    name: '会议'
  }, {
    id: 3,
    name: '沙龙'
  }]
}, {
  id: 'Award',
  name: '等级评价'
}, {
  id: 'Report',
  name: '投稿'
}]
export default {
  data() {
    return {
      menuList,
      currentModule: menuList[0],
      currentItem: menuList[0].children[0],
      showTip: true
    };
  },
  computed: {
    ...mapState(['user']),
    memFeeRangeText() {
      // 缴费确认成功后才展示起止日期
      if (!this.user || this.user.isMemValid != '1') {
        return '';
      }
      const start = this.user.membershipFeeStartDate;
      const end = this.user.membershipFeeValidDate;
      if (!start && !end) {
        return '';
      }
      const fmt = (t) => (t ? moment(t * 1000).format('YYYY-MM-DD') : '-');
      return `${fmt(start)} 至 ${fmt(end)}`;
    },
    showCertificateEntry() {
      if (!this.user) {
        return false;
      }
      if (this.user.memType === 'personal') {
        return true;
      }
      if (this.user.memType === 'org') {
        return true;
      }
      return false;
    },
    certificateEntryText() {
      if (this.user && this.user.memType === 'org') {
        const hasCert = this.user.memOrgVo && this.user.memOrgVo.certificateUrl;
        return hasCert ? '查看 / 下载团体证书' : '团体证书';
      }
      const hasCert = this.user && this.user.memPersonalVo && this.user.memPersonalVo.certificateUrl;
      return hasCert ? '查看 / 下载个人证书' : '个人证书';
    },
  },
  components: {
    FeeRemindBanner,
    Award: () => import('./Award.vue'),
    Activity: () => import('./Activity.vue'),
    Report: () => import('./Report.vue'),
  },
  methods: {
    changeMenu(item) {
      this.currentModule = item;
      if (item.children) {
        this.currentItem = item.children[0];
      }
    },
    changeItem(item) {
      this.currentItem = item;
    },
    goCertificate() {
      if (this.user && this.user.memType === 'org') {
        router.push('/system/user?c=OrgCertificate');
        return;
      }
      router.push('/system/user?c=PersonalCertificate');
    },
  }
};
</script>

<style lang="less" scoped>
.user-box {
  width: 100%;
  min-height: 148px;
  padding: 28px 40px;
  background: url(../../assets/images/member-user-info-bg.png) no-repeat center
    center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 12px;
  box-sizing: border-box;

  .user-flag,
  .user-flag-ing,
  .user-flag-yet {
    width: 90px;
    height: 32px;
    border-radius: 0 0 0 12px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }

  .user-flag {
    background: linear-gradient(135deg, #ff8a4c 0%, #ff6b35 100%);
  }

  .user-flag-ing {
    background: #e3d63a;
  }

  .user-flag-yet {
    background: #30db7c;
  }

  .user-main {
    display: flex;
    align-items: center;
    width: 100%;
    padding-right: 100px;
    box-sizing: border-box;
  }

  .user-img {
    flex: 0 0 72px;
    width: 72px;
    height: 72px;
    margin-right: 24px;

    > img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
  }

  .user-content {
    flex: 1;
    min-width: 0;
  }

  .user-title-row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  .user-name {
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #131415;
    line-height: 1.2;
    margin-right: 12px;
    max-width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .user-type-tag {
    flex-shrink: 0;
    height: 24px;
    padding: 0 10px;
    border-radius: 12px;
    background: rgba(6, 174, 99, 0.12);
    color: #06ae63;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 24px;
  }

  .user-meta-row {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    min-width: 0;
    margin-bottom: 10px;
  }

  .meta-item {
    display: inline-flex;
    align-items: baseline;
    min-width: 0;
    max-width: 100%;

    .meta-label {
      flex-shrink: 0;
      font-style: normal;
      font-size: 13px;
      color: #9a9a9a;
      margin-right: 8px;
      font-family: PingFangSC-Regular, PingFang SC;
    }

    em {
      font-style: normal;
      font-size: 14px;
      color: #333;
      font-family: PingFangSC-Regular, PingFang SC;
      white-space: nowrap;
    }

    &.meta-address {
      flex: 1;
      min-width: 0;

      em {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .meta-divider {
    flex-shrink: 0;
    width: 1px;
    height: 12px;
    background: #d8d8d8;
    margin: 0 16px;
  }

  .user-fee-row {
    display: flex;
    align-items: center;
  }

  .user-cert-row {
    margin-top: 12px;
  }

  .cert-entry-btn {
    height: 32px;
    padding: 0 16px;
    border: 1px solid #06ae63;
    border-radius: 16px;
    background: #fff;
    color: #06ae63;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      background: rgba(6, 174, 99, 0.08);
    }
  }

  .fee-chip {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    height: 28px;
    padding: 0 12px;
    border-radius: 14px;
    background: linear-gradient(90deg, rgba(48, 219, 124, 0.14), rgba(6, 174, 99, 0.08));
    border: 1px solid rgba(6, 174, 99, 0.22);

    .fee-label {
      flex-shrink: 0;
      font-style: normal;
      font-size: 12px;
      color: #06ae63;
      margin-right: 8px;
      font-family: PingFangSC-Medium, PingFang SC;
    }

    em {
      font-style: normal;
      font-size: 13px;
      color: #1f7a4d;
      font-family: PingFangSC-Medium, PingFang SC;
      letter-spacing: 0.2px;
      white-space: nowrap;
    }
  }
}

.banner-box {
  width: 100%;
  height: 180px;
  background: url('http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/member-user-banner-bg.jpg') no-repeat
    center center;
  background-size: 100% 100%;
  position: relative;
  padding: 40px 40px 28px;
  margin-bottom: 12px;

  .banner-name {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 20px;
    margin-bottom: 16px;
  }

  .banner-desc {
    &:extend(.line1);
    width: 349px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    margin-bottom: 30px;
  }

  .card-more {
    width: 102px;
    height: 32px;
    background: #ffffff;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #131415;
    text-align: center;
    line-height: 32px;
    cursor: pointer;

    &:hover {
      color: #06ae63;
    }
  }

  .banner-switch-box {
    position: absolute;
    height: 100%;
    right: 40px;
    top: 0;

    .banner-switch-icon {
      cursor: pointer;
      height: 32px;
      background: url(../../assets/images/member-user-switch-icon-top.png)
        no-repeat center center;
      background-size: 20px 12px;

      &:last-child {
        background-image: url(../../assets/images/member-user-switch-icon-bottom.png);
      }
    }

    .banner-img-box {
      height: 116px;
      position: relative;
      width: 252px;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 6px;
        width: 252px;
        height: 104px;
        background: #ffffff;
        opacity: 0.35;
      }

      img {
        position: relative;
        width: 240px;
        height: 116px;
        display: block;
        margin-left: 6px;
      }
    }
  }
}

.content-main {
  display: flex;
  background: #ffffff;

  &-left {
    flex: 1;
    border-right: 1px solid #f5f5f5;

    .content-menu-box {
      padding: 24px 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      .content-menu-list {
        width: 500px;
        padding: 0 21px;
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;

        .content-menu-item {
          text-align: center;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #787878;
          cursor: pointer;

          &.active {
            color: #06ae63;

            .content-menu-item-icon {
              background-image: url(../../assets/images/member-menu-hd-active.png);
            }
          }

          .content-menu-item-icon {
            width: 40px;
            height: 40px;
            margin: 0 auto;
            margin-bottom: 5px;
            background: url(../../assets/images/member-menu-hd.png) no-repeat
              center 0;
            background-size: 100% 100%;
          }

          &:nth-child(2) {
            .content-menu-item-icon {
              background-image: url(../../assets/images/member-menu-pypj.png);
            }
          }

          &:nth-child(3) {
            .content-menu-item-icon {
              background-image: url(../../assets/images/member-menu-tg.png);
            }
          }
        }
      }
      .content-menu-nav {
        width: 480px;
        border-bottom: 1px solid #f1f3f3;
        display: flex;
        justify-content: space-between;

        .content-menu-nav-item {
          padding-bottom: 8px;
          position: relative;
          width: 80px;
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          cursor: pointer;

          &.active {
            color: #06ae63;
            &::after {
              content: "";
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 6px;
              background: url(../../assets/images/member-menu-nav-active.png)
                no-repeat center 0;
              background-size: 100% 100%;
            }
          }
        }
      }
    }

    .content-list-box {
      .content-list-item {
        padding: 30px 40px;
        border-bottom: 1px solid #e9e9e9;

        &:last-child {
          border-bottom: none;
        }

        &-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 11px;
        }
        &-num {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #131415;
          height: 24px;
          line-height: 24px;
          padding: 0 3px 0 7px;
          background: #F1F3F3;
          border: 1px solid #DDE4E4;
          margin-right: 4px;
        }

        &-left {
          display: flex;
          align-items: center;

          > h4 {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #131415;
          }
        }
        &-info {
          display: flex;
          margin-right: 40px;
        }
        &-icon {
          width: 14px;
          height: 14px;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          margin-right: 8px;

          &.icon-position {
            background-image: url(../../assets/images/icon-position.png);
          }

          &.icon-time {
            background-image: url(../../assets/images/icon-time-light.png);
          }
        }
        &-value {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #787878;
        }
        .card-more {
          width: 84px;
          height: 30px;
          background: #06ae63;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          text-align: center;
          line-height: 30px;
        }
        &-extra {
          display: flex;
          align-items: center;
          margin-bottom: 33px;
        }
        &-body {
          display: flex;
          justify-content: space-between;
          padding: 0 20px;

          &-item {
            position: relative;
            flex: 1;
            height: 62px;

            &:last-child {
              flex: 0;

              &::after {
                display: none;
              }

              .body-item-info {
                width: max-content;
              }
            }

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              width: 16px;
              height: 16px;
              background: #FFFFFF;
              border: 4px solid #DDE4E4;
              box-sizing: border-box;
              border-radius: 50%;
            }

            &.active {
              &::before {
                border-color: #06AE63;
              }
              &::after {
                background: #06AE63;
              }

              .body-item-info {
                color: #06AE63;
              }
            }

            &::after {
              content: '';
              position: absolute;
              left: 16px;
              top: 6px;
              width: ~'calc(100% - 16px)';
              height: 4px;
              background: #DDE4E4;
            }
          }
          
          .body-item-info {
            position: absolute;
            left: 0;
            top: 28px;
            transform: translateX(-50%);
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #787878;

            &.error {
              color: #FF3B2F !important;
            }
          }

          .body-item-time {
            position: absolute;
            left: 0;
            top: 48px;
            transform: translateX(-50%);
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #787878;
          }
        }
      }
    }
  }

  &-right {
    padding: 20px 10px;
    position: relative;

    .other-list {
      &-header {
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 26px;

        img {
          width: 80px;
        }

        .more-btn {
          height: 14px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #9d9e9e;
          line-height: 14px;
          cursor: pointer;
        }
      }

      &-wrap {
        .other-list-item {
          position: relative;
          padding: 0 20px;

          &::before {
            content: "";
            width: 6px;
            height: 6px;
            background: #06ae63;
            border-radius: 50%;
            position: absolute;
            left: 9px;
            top: 4px;
          }

          &:hover {
            .other-list-item-title {
              color: #06ae63;
            }
          }

          &-title {
            &:extend(.line1);
            width: 196px;
            height: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #131415;
            line-height: 14px;
            margin-bottom: 10px;
          }

          &-time {
            height: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #787878;
            line-height: 14px;
          }
        }
      }
    }

    .bottom-box {
      position: absolute;
      width: 250px;
      height: 140px;
      left: 15px;
      bottom: 15px;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
}
</style>